import isBefore from 'date-fns/isBefore';
import isSameDay from 'date-fns/isSameDay';

const isSameOrBefore = (currentDate: Date, endDate: Date) => {
  return isSameDay(currentDate, endDate) || isBefore(currentDate, endDate);
};

export default isSameOrBefore;
